import { render, staticRenderFns } from "./shipment-pending-icon.vue?vue&type=template&id=92bc8e30"
import script from "./shipment-pending-icon.vue?vue&type=script&lang=js"
export * from "./shipment-pending-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports